import { StackValidationStatusDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface ModificationStackValidationState {
  loading: LoadingState;
  result: StackValidationStatusDto | null;
  errors: string | null;
}
export const initialModificationStackValidation: ModificationStackValidationState = {
  loading: LoadingState.idle,
  result: null,
  errors: null,
};
